import styles from './ImagePlaceholder.module.scss';
import { Props } from './ImagePlaceholder.types';

const ImagePlaceholder = ({ height, iconSize, Icon }: Props) => {
  return (
    <div className={styles.container} style={{ height, minHeight: height }}>
      <Icon size={iconSize} className={styles.icon} />
    </div>
  );
};

export default ImagePlaceholder;
